import jwtJsDecode from 'jwt-js-decode';
import jwt_decode from "jwt-decode";

export default {
    getUserNameFromToken,
    getUserDetailsFromToken,
    getRoleFromToken,
    getoperationEntityFromToken,
    getRoleLevelFromToken,
    getUserIDFromToken,
    isTokenExists,
    isFirstLogin,
    getUserDetailsFromTokenV2
}
function getUserNameFromToken() {

    var token = sessionStorage.getItem('token');
    var decoded = jwt_decode(token);

    return decoded.given_name
}

function getUserDetailsFromToken() {

    var token = sessionStorage.getItem('token');
    var decoded = jwt_decode(token);
    let model = {
        id: decoded.userID,
        roleID: decoded.roleID,
        groupID: decoded.groupID,
        operationEntityID: decoded.operationEntityID,
        roleName: decoded.roleName,
        roleLevel: decoded.roleLevel,
        isFirstLogin: decoded.isFirstLogin


    }
    return model;
}

function getUserDetailsFromTokenV2() {

    var token = sessionStorage.getItem('token');
    var decoded = jwt_decode(token);
    let model = {
        id: decoded.userID,
        roleID: decoded.roleID,
        groupID: decoded.groupID,
        operationEntityID: decoded.operationEntityID,
        operationEntities: JSON.parse(decoded.operationEntities),
        roleName: decoded.roleName,
        roleLevel: decoded.roleLevel,
        isFirstLogin: decoded.isFirstLogin


    }
    
    return model;

}

function getRoleFromToken() {

    var token = sessionStorage.getItem('token');
    var decoded = jwt_decode(token);

    return decoded.roleID;
}

function getoperationEntityFromToken() {

    var token = sessionStorage.getItem('token');
    var decoded = jwt_decode(token);

    return decoded.operationEntityID;
}

function getRoleLevelFromToken() {
    var token = sessionStorage.getItem('token');
    var decoded = jwt_decode(token);

    return decoded.roleLevel;
}

function getUserIDFromToken() {

    var token = sessionStorage.getItem('token');
    var decoded = jwt_decode(token);

    return decoded.userID;
}

function isFirstLogin() {
    var token = sessionStorage.getItem('token');
    var decoded = jwt_decode(token);
    return decoded.isFirstLogin;
}

function isTokenExists() {
    var token = sessionStorage.getItem('token');

    if (token == null || token == undefined) {
        return false;
    }

    return true;
}


